export default "<div class=\"blue\">\n    <div class=\"white\">\n        <app-referee-list></app-referee-list>\n    </div>\n</div>";